import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { Router } from '@angular/router';
import { NgIf } from '@angular/common';

@Component({
  selector: 'vex-help-and-support',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent,
    NgIf
  ],
  templateUrl: './help-and-support.component.html',
  styleUrl: './help-and-support.component.scss'
})
export class HelpAndSupportComponent implements OnInit {
  activeTab: string = 'sub-tab1';
  constructor(private router:Router) {}
  ngOnInit() {
    this.toggleMenu('tab1-content');
  }
  goTo(url) {
    this.router.navigateByUrl(url);
  }
  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  toggleMenu(tabId: string) {
    const tabContent = document.getElementById(tabId);
    if (tabContent) {
      tabContent.classList.toggle('hidden');
    }
  }

}
